import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { NavService } from '../../_services/_nav.service';
import { RequisitosService } from '../../_services/requisitos.service';
import { RequisitosRespaldosService } from '../../_services/requisitos-respaldos.service';
import { Requisito } from '../../_models/requisito';
import { RequisitoRespaldo } from '../../_models/requisito-respaldo';
import { RequisitoGarantiaCantidadTipoVinculacion } from '../../_models/requisito-garantia-cantidad-tipo-vinculacion';
import { RequisitoGarantiaModalidad } from '../../_models/requisito-garantia-modalidad';
import { RequisitoGarantiaTipoRespaldo } from '../../_models/requisito-garantia-tipo-respaldo';
import { RequisitoGarantiaCantidadTipoVinculacionService } from '../../_services/requisito-garantia-cantidad-tipo-vinculacion.service';
import { RequisitoGarantiaModalidadService } from '../../_services/requisito-garantia-modalidad.service';
import { RequisitoGarantiaTipoRespaldoService } from '../../_services/requisito-garantia-tipo-respaldo.service';
import { RequisitoGarantiaCantidadService } from '../../_services/requisito-garantia-cantidad.service';
import { RequisitoGarantiaCantidad } from '../../_models/requisito-garantia-cantidad';
import { RequisitosGarantiasProductos } from '../../_models/requisito-garantia-producto';
import { RequisitosGarantiasProductosService } from '../../_services/requisitos-garantia-producto.service';

@Component( {
  selector: 'app-requisitos-detalle',
  templateUrl: 'requisitos-detalle.component.html'
} )

export class RequisitosDetalleComponent implements OnInit {

  requisito: Requisito;
  respaldos: RequisitoRespaldo[] = [];
  lisRespCantidad: RequisitoGarantiaCantidad[] = [];
  lisRequisitoModalidad: RequisitoGarantiaModalidad[] = [];
  lisRequisitoTipoRespaldo: RequisitoGarantiaTipoRespaldo[] = [];
  lisProductos: RequisitosGarantiasProductos[] = [];
  carInformacionInicial = true;
  columnas: any[];
  colTipoVinculacion: any[] = [];
  colTipoRespaldo: any[] = [];
  colModalidad: any[] = [];
  colProductos: any[] = [];

  selRespaldo: RequisitoRespaldo;
  detalle = false;
  tituloDetalle: string;
  textoDetalle: string;

  constructor(
    private route: ActivatedRoute,
    private requisitosServicio: RequisitosService,
    private requisitosRespaldosServicio: RequisitosRespaldosService,
    private reqGarantiaCantidadService: RequisitoGarantiaCantidadService,
    private reqGarantiaTipoVinculacionServie: RequisitoGarantiaCantidadTipoVinculacionService,
    private reqGarantiaModalidadService: RequisitoGarantiaModalidadService,
    private reqGarantiaTipoRespaldoService: RequisitoGarantiaTipoRespaldoService,
    private nav: NavService,
    private location: Location,
    private requisitosProductoService: RequisitosGarantiasProductosService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'requisoto', header: this.nav.buscarMensaje( 'REQUISITOS.LBL_REQUISITOS' ), sort: false },
      { field: 'tipoVinculacion', header: this.nav.buscarMensaje( 'REQUISITOS.LBL_TIPOVINCULACION' ), sort: false },
      { field: 'nombreRespaldo', header: this.nav.buscarMensaje( 'REQUISITOS.LBL_PRODUCTO' ), sort: false },
      { field: 'nombreRespaldo', header: this.nav.buscarMensaje( 'REQUISITOS.LBL_ACTIVIDAD' ), sort: false }
    ];

    this.colModalidad = [
      { field: 'modalidad', header: this.nav.buscarMensaje( 'REQUISITOS.LBL_MODALIDAD' ), sort: false }
    ];

    this.colTipoRespaldo = [
      { field: 'tipoRespaldo', header: this.nav.buscarMensaje( 'REQUISITOS.LBL_TIPOREQUISITO' ), sort: false }
    ];

    this.colTipoVinculacion = [
      { field: 'tipoVinculacion', header: this.nav.buscarMensaje( 'REQUISITOTIPOVINCUACION.LBL_TIPOVINCULACION' ), sort: false },
      { field: 'cantidad', header: this.nav.buscarMensaje( 'REQUISITOTIPOVINCUACION.LBL_CANTIDAD' ), sort: false }
    ];

    /* Columnas data table productos*/
    this.colProductos = [
      {
        field: "productos",
        header: this.nav.buscarMensaje("REQUISITOS.LBL_PRODUCTO"),
        sort: false,
      },
    ];

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin(
        this.requisitosServicio.obtenerPorId( params[ 'id' ] ),
        this.requisitosRespaldosServicio.listadoPorIdRequisitoHabilitado( params[ 'id' ] ),
        this.reqGarantiaModalidadService.listadoPorIdRequisitoHabilitado( params[ 'id' ] ),
        this.reqGarantiaTipoRespaldoService.listadoPorIdRequisitoHabilitado( params[ 'id' ] ),
        this.reqGarantiaCantidadService.listadoPorIdRequisitoHabilitado( params[ 'id' ] ), // TODO
        this.reqGarantiaTipoVinculacionServie.listadoPorIdRequisitoHabilitado( params[ 'id' ] ),
        this.requisitosProductoService.listadoPorIdRequisitoGarantiaHabilitado(params[ 'id' ]) // TODO

      ).subscribe( ( [ requisito, respaldos, lisModalidad, lisTipoRespaldo, lisRespCant, lisTipoVinculacion, lisProductos ] ) => {
        this.requisito = requisito;
        this.respaldos = respaldos.filter( x => x.indicadorHabilitado );
        this.lisRequisitoModalidad = lisModalidad;
        this.lisRequisitoTipoRespaldo = lisTipoRespaldo;
        this.lisRespCantidad = lisRespCant;
        this.lisRespCantidad.forEach(x => x.requisitosGarantiasCantidadTipoVinculaciones = []);
        lisTipoVinculacion.forEach(x => {
          const model = this.lisRespCantidad.find(y => x.idRequisitoGarantiaCantidad === y.idRequisitoGarantiaCantidad);
          if ( model ) {
            model.requisitosGarantiasCantidadTipoVinculaciones.push(Object.assign({}, x));
          }
        });
        this.lisProductos = lisProductos;
        this.cargarListado();
        this.lisRespCantidad.forEach(x => x.tiposVinculaciones = x.requisitosGarantiasCantidadTipoVinculaciones
          .filter(y => y.indicadorHabilitado)
          .map(y => y.tipoVinculacion).join(', '));
        this.carInformacionInicial = false;
      } );
    } );
  }

  regresar() {
    this.location.back();
  }

  detalleTabla(row: RequisitoRespaldo, tipo: string){
    this.selRespaldo = row;
    //this.tituloDetalle ="Detalle";
    if(tipo === "tipoVincularion") {
      this.tituloDetalle = this.nav.buscarMensaje( 'REQUISITOS.LBL_TIPOVINCULACION' );
      this.textoDetalle = row.requisitosGarantiasRespaldosTiposVinculaciones;
    } else if(tipo === "producto") {
      this.tituloDetalle = this.nav.buscarMensaje( 'REQUISITOS.LBL_PRODUCTO' );
      this.textoDetalle = row.requisitosGarantiasRespaldosProductos;
    } else if(tipo === "actividad") {
      this.tituloDetalle = this.nav.buscarMensaje( 'REQUISITOS.LBL_ACTIVIDAD' );
      this.textoDetalle = row.requisitosGarantiasRespaldosActividades;
    }
    this.detalle = true;
  }

  cargarListado() {

    this.respaldos.map(s => {
      if ( s.indicadorHabilitado ) {
        this.requisitosRespaldosServicio.obtenerPorGenerateList(s.idRequisitoGarantiaRespaldo).subscribe(
          data =>{
            if( data && data.requisitosGarantiasRespaldosTiposVinculaciones){
              s.requisitosGarantiasRespaldosTiposVinculaciones = data.requisitosGarantiasRespaldosTiposVinculaciones;

              if(data.requisitosGarantiasRespaldosTiposVinculaciones.length > 45){
                s.tiposVinculaciones = data.requisitosGarantiasRespaldosTiposVinculaciones.substring(0,45);
                s.verMasTiposVinculaciones = true;
              } else {
                s.tiposVinculaciones = data.requisitosGarantiasRespaldosTiposVinculaciones;
                s.verMasTiposVinculaciones = false;
              }
            }
            if( data && data.requisitosGarantiasRespaldosActividades){
              s.requisitosGarantiasRespaldosActividades = data.requisitosGarantiasRespaldosActividades;
              if(data.requisitosGarantiasRespaldosActividades.length > 45){
                s.actividades = data.requisitosGarantiasRespaldosActividades.substring(0,45);
                s.verMasActividades = true;
              } else {
                s.actividades = data.requisitosGarantiasRespaldosActividades;
                s.verMasActividades = false;

              }
            }
            if( data && data.requisitosGarantiasRespaldosProductos){
              s.requisitosGarantiasRespaldosProductos = data.requisitosGarantiasRespaldosProductos;
              if(data.requisitosGarantiasRespaldosProductos.length > 45){
                s.productos = data.requisitosGarantiasRespaldosProductos.substring(0,45);
                s.verMasProductos = true;
              } else {
                s.productos = data.requisitosGarantiasRespaldosProductos;
                s.verMasProductos = false;
              }
            }
          });
      }
    });
  }
}
